import { render, staticRenderFns } from "./CiCookieLayer.vue?vue&type=template&id=45f0a289&scoped=true&"
import script from "./CiCookieLayer.vue?vue&type=script&lang=js&"
export * from "./CiCookieLayer.vue?vue&type=script&lang=js&"
import style0 from "./CiCookieLayer.vue?vue&type=style&index=0&id=45f0a289&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f0a289",
  null
  
)

component.options.__file = "CiCookieLayer.vue"
export default component.exports